import { useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { ArrowUturnLeftIcon } from '@heroicons/react/20/solid'
import { resetGroupIndividualOverride } from 'redux/slices/activeWorkoutV5'
import { useGetExercises } from 'redux/customHooks/useGetExercises'

import UserProfilePicture from 'components/User/UserProfilePicture'
import VolumeCompletedV5 from 'components/ActiveWorkoutV5/VolumeCompletedV5'
import LoadCompletedV5 from 'components/ActiveWorkoutV5/LoadCompletedV5'
import ActionButtonsV5 from 'components/ActiveWorkoutV5/ActionButtonsV5'

export default function GroupIndividualExerciseSetListItemV5({ 
    kinesisWorkoutAssignmentType,
    groupIndividual,
    phaseIndex, 
    slotIndex, 
    exercise, 
    setIndex, 
    set
}) {
    const dispatch = useDispatch()

    const { urlWorkoutId } = useParams()

    const { exercises } = useGetExercises()

    const ResetGroupIndividualOverrideInputs = () => {
        const payload = {
            workoutId: urlWorkoutId,
            groupIndividualId: groupIndividual.id,
            phaseIndex: phaseIndex,
            slotIndex: slotIndex,
            setIndex: setIndex
        }

        dispatch(resetGroupIndividualOverride(payload))
    }

    const groupIndividualSet = groupIndividual?.workout?.phases[phaseIndex]?.slots[slotIndex]?.sets[setIndex];
    const isCompleted = groupIndividualSet.completed
    const isSkipped = groupIndividualSet.skipped

    if (exercises.length === 0) { 
        return (
            <div className='w-full h-32 p-4'>
                <div className='w-full h-full bg-gray-200 rounded-lg animate-pulse' />
            </div>
        )
    }

    return (
        <div className='w-full p-4 flex items-center gap-x-4'>
            <div className='flex items-center gap-x-2'>
                <div className='w-20 h-20 p-2 flex items-center justify-center'>
                    <UserProfilePicture 
                        firstName={groupIndividual?.firstName} 
                        lastName={groupIndividual?.lastName} 
                        size='large'
                        shadow={false} 
                    />
                </div>

                <p className='w-[250px] text-lg truncate'>
                    {groupIndividual?.firstName} {groupIndividual?.lastName}
                </p>
            </div>

            <div className='flex-1' />

            {isSkipped === 0 && (
                <>
                    <LoadCompletedV5
                        kinesisWorkoutAssignmentType={kinesisWorkoutAssignmentType}
                        groupIndividual={groupIndividual}
                        phaseIndex={phaseIndex}
                        slotIndex={slotIndex}
                        exercise={exercise}
                        setIndex={setIndex}
                        set={set}
                        isCompleted={isCompleted}
                        isSkipped={isSkipped}
                        showLabel={false}
                    />  

                    <VolumeCompletedV5
                        kinesisWorkoutAssignmentType={kinesisWorkoutAssignmentType}
                        groupIndividual={groupIndividual}
                        phaseIndex={phaseIndex}
                        slotIndex={slotIndex}
                        exercise={exercise}
                        setIndex={setIndex}
                        set={set}
                        isCompleted={isCompleted}
                        isSkipped={isSkipped}
                        showLabel={false}
                    />
                </>
            )}

            <ActionButtonsV5
                kinesisWorkoutAssignmentType={kinesisWorkoutAssignmentType}
                groupIndividual={groupIndividual}
                phaseIndex={phaseIndex}
                slotIndex={slotIndex}
                exercise={exercise}
                setIndex={setIndex}
                set={set}
                isCompleted={isCompleted}
                isSkipped={isSkipped}
                showLabel={false}
            />

            {!groupIndividualSet.groupIndividualOverride && (
                <div className='w-[28px]' />
            )}

            {groupIndividualSet.groupIndividualOverride && (
                <div 
                    className='w-[28px]'
                    onClick={ResetGroupIndividualOverrideInputs}
                >
                    <ArrowUturnLeftIcon className='w-8 h-8 text-gray-600 cursor-pointer' />
                </div>
            )} 
        </div>
    )
}